
import { Component, Mixins, Watch } from 'vue-property-decorator';
import { RecentShipments as RecentShipmentsWidget, RecentShipment } from '@/features/dashboard/types';
import Content from '@/features/dashboard/components/widgets/recentShipments/Content.vue';
import { getMarkerStyle } from '@/features/common/helpers';
import { getRecentShipmentsData } from '@/features/dashboard/services/dashboard.services';
import DataRowSkeleton from '@/features/dashboard/components/widgets/DataRowSkeleton.vue';
import eventBus from '@/features/common/eventBus';
import eventNames from '@/features/common/constants/events';
import { WidgetMixin } from '../widgetMixin';

interface ShowStatuses {
  created: boolean,
  intransit: boolean,
  delivered: boolean,
  exception: boolean,
}

@Component({
  components: {
    Content,
    DataRowSkeleton,
  },
})
export default class RecentShipments extends Mixins(WidgetMixin) {
  private shipmentsShown = 3;

  private shipmentsShownItems = Array.from({ length: 25 }, (_, i) => i + 1)

  private colors: Array<string> = ['#623ec7', '#ffa43c', '#cb0f51', '#2bc5cb'];

  private isLoading = true;

  private showStatuses: ShowStatuses = {
    created: true,
    intransit: true,
    delivered: true,
    exception: true,
  }

  get recentShipments(): Array<RecentShipment> {
    let shipments = this.$store.getters.getRecentShipments;

    shipments = shipments.filter((shipment: RecentShipment) => {
      return this.showStatuses[shipment.status.toLowerCase().replace(' ', '')];
    });

    shipments = shipments.splice(0, this.shipmentsShown);

    return shipments;
  }

  get isDashboardSettingsLoaded(): number {
    return this.$store.getters.getIsDashboardSettings;
  }

  get widget(): RecentShipmentsWidget {
    return this.$store.getters.getWidgets.recentShipments;
  }

  private getMarkerStyle = getMarkerStyle;

  @Watch('isDashboardSettingsLoaded', { immediate: true })
  private loadRecentShipments(newValue: boolean) {
    if (newValue) {
      this.shipmentsShown = (this.widget.itemsShown || 3) as number;
      if (this.widget.customSettings) {
        this.showStatuses = { ...this.widget.customSettings };
      }
      this.updateWidgetData();
    }
  }

  private async updateWidgetData() {
    this.isLoading = true;
    this.rerenderWidget();
    const recentShipments: Array<RecentShipment> = await getRecentShipmentsData(
      this.shipmentsShown,
      0,
      this.showStatuses.created,
      this.showStatuses.intransit,
      this.showStatuses.delivered,
      this.showStatuses.exception,
    );
    this.$store.commit('setRecentShipments', recentShipments);
    this.isLoading = false;
    this.rerenderWidget();
    eventBus.$emit(eventNames.DASHBOARD_WIDGET_DATA_LOADED);
  }

  private handleApply(widgetName: string) {
    this.apply('big');

    this.$store.dispatch('syncDashboardSetting', {
      dashboardWidget: widgetName,
      visible: true,
      position: this.currentPosition,
      itemsShown: this.shipmentsShown,
      customSettings: {
        created: this.showStatuses.created,
        intransit: this.showStatuses.intransit,
        delivered: this.showStatuses.delivered,
        exception: this.showStatuses.exception,
      },
    });

    if (this.position !== this.currentPosition) {
      this.$store.dispatch('patchDashboardSetting', { size: 'big' });
      eventBus.$emit(eventNames.SORT_DASHBOARD_WIDGETS_POSITION, 'big');
    }

    this.updateWidgetData();
  }
}
